import { render, staticRenderFns } from "./AttributeLanguageSelector.vue?vue&type=template&id=5b4460d2&scoped=true"
import script from "./AttributeLanguageSelector.vue?vue&type=script&lang=js"
export * from "./AttributeLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./AttributeLanguageSelector.vue?vue&type=style&index=0&id=5b4460d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4460d2",
  null
  
)

export default component.exports